<!-- //
分页
@auth xuyd
@date 2024-05-01
//-->
<template>
  <div class="pagination-container">
    <el-pagination
        class="fl"
        v-show="total > 0"
        @current-change="pageChangeHandler"
        @size-change="sizeChangeHandler"
        :page-sizes="[10, 20, 50, 100]"
        :current-page.sync="_pageNum"
        :page-size.sync="_pageSize"
        :layout="layout"
        :total="total">
    </el-pagination>
    <span class="skip" v-show="total > 0" @click="pageChangeHandler">跳转</span>
  </div>
</template>

<script>
  export default {
    name: 'Pagination',
    props: {
      total: {
        required: true,
        type: Number
      },
      pageNum: {
        required: true,
        type: Number
      },
      pageSize: {
        required: true,
        type: Number
      },
      layout: {
        required: false,
        type: String,
        default: "total, sizes, prev, pager, next, jumper"
      },
    },
    data() {
      return {}
    },
    computed: {
      /**
       * 页码
       */
      _pageNum: {
        get() {
          return this.pageNum
        },
        // 当一个子组件改变了一个 prop 的值时，这个变化也会同步到父组件中所绑定
        set(val) {
          this.$emit('update:pageNum', val)
        }
      },
      /**
       * 每页size
       */
      _pageSize: {
        get() {
          return this.pageSize
        },
        set(val) {
          this.$emit('update:pageSize', val)
        }
      }
    },
    methods: {
      /**
       * 页size change
       * @param pageSize
       */
      sizeChangeHandler(pageSize) {
        let maxPage = Math.ceil(this.total / pageSize);
        let currentPage = this._pageNum;
        if(currentPage > maxPage) {
          currentPage = maxPage;
        }
        this._pageNum = currentPage;
        this.$emit('pagination', {pageNum: this._pageNum, pageSize: pageSize})
      },
      /**
       * 页码change
       * @param pageNum
       */
      pageChangeHandler(pageNum) {
        this.$emit('pagination', {pageNum: pageNum, pageSize: this.pageSize})
      },
    }

  }
</script>

<style scoped>
  .pagination-container {
    height: 30px;
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
  }

  .skip {
    cursor: pointer;
    float: left;
    margin: 8px 0 0 10px;
    color: #409EFF;
  }
</style>
